import React from 'react';

// styles
import "./assets/css/bootstrap.min.css";
import "./assets/css/StyleSheet.css";

// routes
import { Switch, Route } from 'react-router-dom'

// components
import ModalCookies from './components/pages/Modal/ModalCookies';
import Navigation from './components/ui/Navigation';
import Footer from './components/ui/Footer'
import NotFound from './components/ui/NotFound';

import Home from './components/pages/Home/Home';
import Contact from './components/pages/Contact/Contact';
import Cookies from './components/pages/Legal/Cookies';
import LegalWarning from './components/pages/Legal/LegalWarning';
import PrivacyPolicy from './components/pages/Legal/PrivacyPolicy';
import Politics from './components/pages/Legal/Politics';
import EthicalCode from './components/pages/Legal/EthicalCode';
import GeneralWork from './components/pages/WorkWithUs/GeneralWork';


function App() {

    return (
        <>
            <Navigation />

            <Switch>

                <Route exact path="/"><Home /></Route>
                <Route exact path="/trabaja-con-nosotros"><GeneralWork /></Route>
                <Route exact path="/contacto"><Contact /></Route>
                <Route exact path="/politica-de-cookies"><Cookies /></Route>
                <Route exact path="/aviso-legal"><LegalWarning /></Route>
                <Route exact path="/politica-privacidad-proteccion-datos"><PrivacyPolicy /></Route>
                <Route exact path="/politicas-de-calidad"><Politics /></Route>
                <Route exact path="/codigo-etico"><EthicalCode /></Route>
                <Route exact path="/politicas-de-calidad"><Politics /></Route>
                <Route path="*" component={NotFound}><NotFound /></Route>

            </Switch>

            <ModalCookies />

            <Footer />
        </>
    );
}

export default App;